import { PlusOutlined } from "@ant-design/icons"
import { Card, Flex, Tooltip, Typography } from "antd"
import React from "react"

import type { DocumentAvailableBlock } from "../../types/types.ts"

interface SidebarBlockItemProps {
  block: DocumentAvailableBlock
  onAdd: (block: DocumentAvailableBlock) => void
  disabled?: boolean
}

export function DocumentTemplateFormGroupsItem({
  block,
  onAdd,
  disabled
}: SidebarBlockItemProps) {
  return (
    <Tooltip
      title={
        disabled
          ? `Maximum ${block.max_per_template} per template reached`
          : block.description
      }
      placement="right"
    >
      <Card
        hoverable
        size={"small"}
        onClick={() => !disabled && onAdd(block)}
        className={disabled ? "pointer-events-none opacity-50" : ""}
      >
        <Flex gap={"small"}>
          <Flex
            flex={1}
            align="center"
            gap="small"
            className={"overflow-hidden"}
          >
            {/*<span>{block.icon}</span>*/}
            <Typography.Text ellipsis style={{ color: "inherit" }}>
              {block.label}
            </Typography.Text>
          </Flex>

          {!disabled && (
            <PlusOutlined className="sidebar-block-item__add-icon" />
          )}
        </Flex>
      </Card>
    </Tooltip>
  )
}
